import React from 'react'

import { createStyles, WithStyles, withStyles, Theme } from '@material-ui/core/styles'
import { Typography, Grid, List, ListItem } from '@material-ui/core'

import { IGameDetailsResponse } from 'protos'
import quizRibbonUrl from 'assets/images/quiz_ribbon.svg'

import QuizListItem from './components/QuizListItem'
import QuizOutcome from './components/QuizOutcome'

interface Props {
  gameDetails: IGameDetailsResponse
  onAnswerSubmit: (questionId: string, answerId: string) => void
}

const styles = (theme: Theme) => createStyles({
  sectionHeader: {
    backgroundColor: theme.palette.grey[100],
  },
  icon: {
    marginRight: theme.spacing() * 2,
    height: 48,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const QuizTab: React.SFC<InjectedProps> = ({ gameDetails, onAnswerSubmit, classes }) => {
  const { quiz: sections, quizOutcomeImageUrl, quizOutcomeTitle, quizOutcomeMessage } = gameDetails

  return (
    <>
      {Boolean(quizOutcomeTitle || quizOutcomeMessage) && (
        <QuizOutcome title={quizOutcomeTitle} message={quizOutcomeMessage} imageUrl={quizOutcomeImageUrl} />
      )}
      {(sections || []).map((section, i) => {
        const questions = (section.question || [])
        const totalAnsweredQuestions = questions.filter(question => Boolean(question.selectedAnswerId)).length

        return (
          <List key={i} disablePadding>
            <ListItem divider className={classes.sectionHeader}>
              <img alt="" src={section.iconUrl || quizRibbonUrl} className={classes.icon} />
              <Grid item xs>
                <Typography variant="body1">{section.title}</Typography>
              </Grid>
              <Typography variant="h4">
                {questions.length > 0
                  ? `${totalAnsweredQuestions} / ${questions.length}`
                  : '-'
                }
              </Typography>
            </ListItem>
            {questions.map(question => (
              <QuizListItem
                key={question.questionId!}
                question={question}
                onAnswerSubmit={(answerId) => onAnswerSubmit(question.questionId!, answerId)}
              />
            ))}
          </List>
        )
      })}
    </>
  )
}

export default withStyles(styles)(QuizTab)
